import {TopNav} from "./TopNav";
import { BottomNav } from "./BottomNav";

export const Navbar = () => {
    return (
        <>
        <TopNav />
        <BottomNav />
        </>
    )
}